<template>
  <div id="login" class="login f-c-s">
    <div class="loginpage f-c-s f-d-c w-66 h-100">
      <div class="f-c-c w-100 h-15">
        <Navbar />
      </div>
      <div
        class="f-c-sa justifyContent1400 pl-5 pr-5 w-100 h-70"
        style="margin-right: 40px"
      >
        <div class="loginBox f-c-s f-d-c w-CompletionInformation">
          <div class="title w-100 f-c-c mt-4 mb-5">ثبت نام</div>
          <div class="completionInputSec f-c-b w-100">
            <div class="f-c-s">
              <div class="inputLabel f-c-s">نام</div>
              <input
                type="text"
                autofocus
                v-model="name"
                @keyup.enter="enterMobileFunc()"
              />
            </div>
            <div class="f-c-e">
              <div class="inputLabel f-c-s mr-2">نام خانوادگی</div>
              <input
                type="text"
                autofocus
                v-model="family"
                @keyup.enter="enterMobileFunc()"
              />
            </div>
          </div>
          <div class="completionInputSec f-c-b w-100">
            <div class="f-c-s searchSelectBox">
              <div class="inputLabel f-c-s">حقوقی/حقیقی</div>
              <select v-model="realLegal">
                <option value="yes">حقوقی</option>
                <option value="no">حقیقی</option>
              </select>
            </div>
            <div
              class="f-c-e searchSelectBox"
              :class="[realLegal == 'no' ? 'disabledSelect' : '']"
            >
              <div class="inputLabel f-c-s mr-2">سازمان</div>
              <v-select
                v-model="organization"
                :disabled="realLegal == 'no'"
                @input="setSelected"
                :title="organizationTitle"
                :options="allOrganization.information"
                :reduce="(option) => option.id"
                label="title"
              />
            </div>
            <!-- <div class="f-c-e">
              <div class="inputLabel f-c-e">ایمیل</div>
              <input
                type="email"
                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                placeholder="example@email.com"
                autocomplete="off"
                v-model="email"
                @keyup.enter="enterMobileFunc()"
              />
            </div> -->
          </div>
          <!-- <div class="completionInputSec f-c-b w-100 mb-4">
            <div class="f-c-s">
              <div class="inputLabel f-c-e">جنسیت</div>
              <select class="gender" v-model="gender">
                <option value="male">مرد</option>
                <option value="female">زن</option>
              </select>
            </div>
            <div class="f-c-e searchSelectBox">
              <div class="inputLabel f-c-e">سازمان</div>
              <v-select
              v-model="organization"
              @input="setSelected"
              :title="organizationTitle"
              :options="allOrganization.information"
              :reduce="(option) => option.id" label="title"
            />
            </div>
          </div> -->
          <div class="completionInputSec f-c-b w-100">
            <div class="f-c-s">
              <div class="inputLabel f-c-s">تلفن همراه</div>
              <input
                type="number"
                v-model="phone"
                autocomplete="false"
                @keyup.enter="enterMobileFunc()"
              />
            </div>
            <div class="f-c-e">
              <div class="inputLabel f-c-s mr-2">رمز عبور</div>
              <input type="password" v-model="password" autocomplete="false"/>
            </div>
          </div>
          <div class="completionInputSec f-c-b w-100">
            <div class="f-c-s">
              <div class="inputLabel f-c-s">تکرار رمز</div>
              <input
                type="password"
                v-model="rPassword"
                autocomplete="false"
                @keyup.enter="enterMobileFunc()"
              />
            </div>
            <div class="f-c-e" style="position: relative">
              <div class="inputLabel f-c-s mr-2">کد امنیتی</div>
              <div class="captchaItem">
                <input v-model="captcha" type="text" />
                <img
                  :src="
                    'https://vadaroom.ec.iau.ir/captcha.php?ver=' + randCaptcha
                  "
                  alt=""
                  style="
                    width: 55px;
                    margin-bottom: 0.5rem;
                    position: absolute;
                    top: -25px;
                    left: 5px;
                    z-index: 0;
                  "
                />
              </div>
            </div>
          </div>
          <div
            class="enterBtn f-c-c"
            @click.prevent="isWaiting ? '' : enterMobileFunc()"
          >
            {{ isWaiting ? "در حال ارسال" : "ثبت" }}
          </div>
        </div>
        <!-- <img
          id="loginJsonAnimation"
          :src="require(`@/assets/images/login/register.svg`)"
        /> -->
      </div>

      <div class="gapMaterial pl-5 pr-5 f-c-b w-100 h-15">
        <div class="text f-c-c">
          کلیه حقوق مادی و معنوی متعلق به دانشگاه آزاد اسلامی واحد الکترونیکی می
          باشد.
        </div>
        <a
          data-v-efcdee58=""
          referrerpolicy="origin"
          target="_blank"
          href="https://trustseal.enamad.ir/?id=326758&amp;Code=bjOij5apDKj7OdTL5Wi7"
          ><img
            data-v-efcdee58=""
            referrerpolicy="origin"
            src="https://vadaroom.ec.iau.ir/img/logo_enamad.png"
            alt=""
            id="bjOij5apDKj7OdTL5Wi7"
            style="cursor: pointer; width: 100%; height: 100%"
        /></a>
      </div>
    </div>
    <div class="area loginArea">
      <ul class="circles">
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/1.png`)"
          ></b-img>
        </li>
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/2.png`)"
          ></b-img>
        </li>
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/3.png`)"
          ></b-img>
        </li>
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/4.png`)"
          ></b-img>
        </li>
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/5.png`)"
          ></b-img>
        </li>
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/6.png`)"
          ></b-img>
        </li>
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/7.png`)"
          ></b-img>
        </li>
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/8.png`)"
          ></b-img>
        </li>
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/9.png`)"
          ></b-img>
        </li>
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/10.png`)"
          ></b-img>
        </li>
      </ul>
    </div>
  </div>

  <!-- <div class="login register">
    <Navbar />
    <div class="loginBox f-c-s f-d-c">
      <div class="title w-100 f-c-c mt-4 mb-3">ثبت نام</div>
      <div class="completionInputSec f-c-b w-100 mb-3">
        <div class="inputLabel f-c-s">نام</div>
        <input type="text" autofocus v-model="name" @keyup.enter="enterMobileFunc()" />
      </div>
      <div class="completionInputSec f-c-b w-100 mb-3">
        <div class="inputLabel f-c-s">تلفن همراه</div>
        <input type="number" v-model="phone" @keyup.enter="enterMobileFunc()" />
      </div>
      <div class="completionInputSec f-c-b w-100 mb-3">
        <div class="inputLabel f-c-s">جنسیت</div>
        <select class="gender" v-model="gender">
          <option value="male">مرد</option>
          <option value="female">زن</option>
        </select>
      </div>
      <div class="completionInputSec f-c-b w-100 mb-3">
        <div class="inputLabel f-c-s">رمز عبور</div>
        <input type="password" v-model="password" />
      </div>
      <div class="completionInputSec f-c-b w-100 mb-3">
        <div class="inputLabel f-c-s">تکرار رمز</div>
        <input
          type="password"
          v-model="rPassword"
          @keyup.enter="enterMobileFunc()"
        />
      </div>
      <div class="completionInputSec f-c-b w-100 mb-3">
        <div class="inputLabel f-c-s">سازمان</div>
        <input type="text" v-model="organization" />
      </div>
      <div class="enterBtn f-c-c" @click.prevent="enterMobileFunc()">
        {{ isWaiting ? "در حال ارسال" : "ثبت" }}
      </div>
    </div>
    <div class="gapMaterial gapMaterialLogin f-e-b">
      <div class="text f-c-c">
        کلیه حقوق مادی و معنوی متعلق به دانشگاه آزاد اسلامی واحد الکترونیکی می
        باشد.
      </div>
      <a
        style="width: 100px; height: 100px"
        referrerpolicy="origin"
        target="_blank"
        href="https://trustseal.enamad.ir/?id=326758&amp;Code=bjOij5apDKj7OdTL5Wi7"
        ><img
          referrerpolicy="origin"
          src="https://Trustseal.eNamad.ir/logo.aspx?id=326758&amp;Code=bjOij5apDKj7OdTL5Wi7"
          alt=""
          style="cursor: pointer;width: 100%; height: 100%"
          id="bjOij5apDKj7OdTL5Wi7"
      /></a>
    </div>

  </div> -->
</template>

<script>
import CopyRight from "@/components/CopyRight.vue";
import { EventBus } from "@/assistant/EventBus";
import { mapState, mapActions } from "vuex";
import Navbar from "@/components/LoginNavbar";

export default {
  name: "Register",
  data() {
    return {
      phone: "",
      captcha: "",
      name: "",
      family: "",
      email: "",
      realLegal: "yes",
      searchOrg: "",
      organization: "",
      organizationTitle: "",
      gender: "",
      password: "",
      rPassword: "",
      isWaiting: false,
      isShowCopy: false,
      randCaptcha: 123456,
    };
  },
  created() {
    this.getOrganizationFunction({
      user_id: 0,
    });
    this.isShowNavFunction(1);
    EventBus.$on("copyright", (status) => {
      if (status && this.isShowCopy) {
        this.isShowCopy = false;
      }
    });
  },
  computed: {
    ...mapState({
      register: (state) => state.gap.register,
      changeMobile: (state) => state.gap.changeMobile,
      allOrganization: (state) => state.gap.organization,
    }),
  },
  components: { Navbar, CopyRight },
  methods: {
    ...mapActions("gap", [
      "registerFunction",
      "verificationStatusFunction",
      "isShowNavFunction",
      "getOrganizationFunction",
    ]),
    setSelected(v) {
      const result = this.allOrganization.information.filter((a) => {
        return parseInt(a.id) == parseInt(v);
      });
      if (result[0]) {
        this.organizationTitle = result[0].title;
      } else {
        this.organizationTitle = "";
      }
    },
    mobileNumber(Number) {
      var IndNum = /^[0]?[789]\d{9}$/;

      if (IndNum.test(Number) && Number.length == 11) {
        return true;
      } else {
        return false;
      }
    },
    validateEmail(email) {
      return email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
    },
    copyRightFunc() {
      this.isShowCopy = !this.isShowCopy;
    },
    enterMobileFunc() {
      if (
        this.name == "" ||
        this.phone == "" ||
        this.password == "" ||
        this.rPassword == "" ||
        this.family == "" ||
        this.captcha == ""
      ) {
        this.$bvToast.toast("پر کردن تمام موارد الزامی می باشد.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      } else if (this.password !== this.rPassword) {
        this.$bvToast.toast("پسورد و تکرار آن با هم مساوی نیستند.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      } else if (!this.mobileNumber(this.phone)) {
        this.$bvToast.toast("تلفن همراه را بصورت صحیح وارد نمایید.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      } else if (this.organization == "" && this.realLegal == "yes") {
        this.$bvToast.toast("پر کردن سازمان الزامی می باشد.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      } else {
        this.isWaiting = true;
        this.registerFunction({
          first_name: this.name,
          last_name: this.family,
          mobile: this.phone,
          org: this.organization,
          password: this.password,
          captcha: this.captcha,
          is_organ: this.realLegal,
        });
      }
    },
    randomInteger(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
  },
  watch: {
    register(n) {
      if (Object.keys(n).length) {
        if (n.code == 104 || n.code == 108) {
          this.isWaiting = false;
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
          this.verificationStatusFunction(1);
          setTimeout(() => {
            this.$router.push({ name: "verification" });
          }, 2000);
        } else {
          this.randCaptcha = this.randomInteger(10000, 999999);
          this.isWaiting = false;
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
  },
  mounted() {
    this.randCaptcha = this.randomInteger(10000, 999999);
    // if (Object.keys(this.user).length && this.user.user_id) {
    //   this.$router.push({ name: "myUsers" });
    // }
    // if (Object.keys(this.changeMobile).length) {
    //   this.name = this.changeMobile.name;
    //   this.phone = this.changeMobile.mobile;
    //   this.organization = this.changeMobile.org;
    //   this.gender = this.changeMobile.gender;
    //   this.password = this.changeMobile.password;
    //   this.rPassword = this.changeMobile.password;
    // }
  },
};
</script>
<style lang="scss" scoped>
.circles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.circles li {
  position: absolute;
  display: block;
  list-style: none;
  width: 20px;
  height: 20px;
  animation: animate 20s linear infinite;
  bottom: -30px;
}

.circles li:nth-child(1) {
  left: 3%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
}

.circles li:nth-child(2) {
  left: 5%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
  animation-duration: 12s;
  bottom: 150px;
}

.circles li:nth-child(3) {
  left: 7%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
}

.circles li:nth-child(4) {
  left: 90%;
  width: 60px;
  height: 60px;
  animation-delay: 0s;
  animation-duration: 18s;
  bottom: 100px;
}

.circles li:nth-child(5) {
  left: 7%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
}

.circles li:nth-child(6) {
  left: 95%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
  bottom: 200px;
}

.circles li:nth-child(7) {
  left: 95%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
}

.circles li:nth-child(8) {
  left: 90%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
  animation-duration: 45s;
  bottom: 170px;
}

.circles li:nth-child(9) {
  left: 93%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
  animation-duration: 35s;
  bottom: 50px;
}

.circles li:nth-child(10) {
  left: 2%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
  animation-duration: 11s;
}

@keyframes animate {
  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 0.3;
  }

  100% {
    transform: translateY(-1000px) rotate(720deg);
    opacity: 0;
  }
}
</style>